import { render } from "./FooterComponent.vue?vue&type=template&id=67a94838&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=67a94838&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a94838"]])

export default __exports__